import { render, staticRenderFns } from "./ErrorCode.vue?vue&type=template&id=47190bb4"
import script from "./ErrorCode.vue?vue&type=script&lang=js"
export * from "./ErrorCode.vue?vue&type=script&lang=js"
import style0 from "./ErrorCode.vue?vue&type=style&index=0&id=47190bb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports